'use client';
import React from 'react';
import Link from 'next/link';
import { useLanguage } from '@/context/LanguageContext';

const examples = [
  { id: 'ex-reels', labelKey: 'exReels', icon: '📱', color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'ex-tiktok', labelKey: 'exTiktok', icon: '🎵', color: 'text-accent', bg: 'bg-accent/10' },
  { id: 'ex-shorts', labelKey: 'exShorts', icon: '▶️', color: 'text-mint', bg: 'bg-mint/10' },
  { id: 'ex-animated', labelKey: 'exAnimated', icon: '✨', color: 'text-secondary-foreground', bg: 'bg-secondary' },
  { id: 'ex-books', labelKey: 'exBooks', icon: '📚', color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'ex-voice', labelKey: 'exVoice', icon: '🎙️', color: 'text-accent', bg: 'bg-accent/10' },
  { id: 'ex-ads', labelKey: 'exAds', icon: '📣', color: 'text-mint', bg: 'bg-mint/10' },
  { id: 'ex-marketing', labelKey: 'exMarketing', icon: '🚀', color: 'text-secondary-foreground', bg: 'bg-secondary' },
  { id: 'ex-character', labelKey: 'exCharacter', icon: '🧑‍🎨', color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'ex-digital', labelKey: 'exDigital', icon: '💎', color: 'text-accent', bg: 'bg-accent/10' },
  { id: 'ex-podcast', labelKey: 'exPodcast', icon: '🎧', color: 'text-mint', bg: 'bg-mint/10' },
  { id: 'ex-course', labelKey: 'exCourse', icon: '🎓', color: 'text-secondary-foreground', bg: 'bg-secondary' },
];

export default function CreationExamples() {
  const { t } = useLanguage();
  const ce = t?.creationExamples;

  return (
    <section className="py-24 bg-card">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="text-center mb-14">
          <p className="text-xs font-600 uppercase tracking-widest text-accent mb-3">
            {ce?.sectionLabel ?? 'What Can You Create?'}
          </p>
          <h2 className="text-hero-md font-700 text-foreground mb-4">
            {ce?.sectionTitle ?? 'Unlimited Creative Possibilities'}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base">
            {ce?.sectionSubtitle ?? 'From viral social content to full digital products — AIMaker Studio has a workflow for every creative need.'}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 2xl:grid-cols-6 gap-4">
          {examples?.map((ex) => (
            <Link
              href="/create-page"
              key={ex?.id}
              className="glass-card glass-card-hover rounded-2xl p-5 flex flex-col items-center text-center gap-3 group"
            >
              <div className={`w-12 h-12 rounded-xl ${ex?.bg} flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-200`}>
                {ex?.icon}
              </div>
              <span className={`text-xs font-600 ${ex?.color} leading-tight`}>
                {ce?.[ex.labelKey as keyof typeof ce] ?? ex.labelKey}
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            href="/create-page"
            className="btn-primary px-8 py-3.5 rounded-xl text-sm inline-flex items-center gap-2"
          >
            {ce?.startCreating ?? 'Start Creating Now'} →
          </Link>
        </div>
      </div>
    </section>
  );
}